export const opportunities = (t) => [
    {
        icon: 'icon-fi_grid',
        label: t('commerce.detail.content_gaps.opportunities.all'),
        key: 'all',
        hint: '',
    },
    {
        label: t('commerce.detail.content_gaps.opportunities.untapped'),
        key: 'untapped',
        icon: 'icon-grid-03',
    },
    {
        label: t('commerce.detail.content_gaps.opportunities.highSearchVolume'),
        key: 'high_search_volume',
        icon: 'icon-file-04',
    },
    {
        label: t('commerce.detail.content_gaps.opportunities.lowKd'),
        key: 'low_competition',
        icon: 'icon-intersect-circle',
    },
    {
        label: t('commerce.detail.content_gaps.opportunities.strikingDistance'),
        key: 'striking_distance',
        icon: 'icon-grid-03',
    },
    {
        label: t('commerce.detail.content_gaps.opportunities.page2'),
        key: 'page_2',
        icon: 'icon-file-04',
    },
    {
        label: t('commerce.detail.content_gaps.opportunities.competitorOnlyRankings'),
        key: 'competitor_only_rankings',
        icon: 'icon-intersect-circle',
    },
];
